import { render, staticRenderFns } from "./crowdBaseConfiguration.vue?vue&type=template&id=100590dc&scoped=true&"
import script from "./crowdBaseConfiguration.vue?vue&type=script&lang=js&"
export * from "./crowdBaseConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100590dc",
  null
  
)

component.options.__file = "crowdBaseConfiguration.vue"
export default component.exports